import React from 'react';
import { DeviceCategoryType } from '../../utils/Constants';
import DeviceGroup from '../device-groups';

const EnergyMeterGroup = () => {
    return (
        <>
            <DeviceGroup type={DeviceCategoryType.ENERGYMETER}></DeviceGroup>
        </>
    );
};

export default EnergyMeterGroup;
